import { useMemo } from "react";
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import { usersAPI } from "@/api";
import { useApiSearch } from "@/hooks/useApiSearch";

export const SeminarianSelection = ({state, setFieldInState}) => {

    const paramsForSeminariansInCourses = useMemo(() => {
            return (
                { 
                    ...(state.direction_id && {'employeeDirection': state.direction_id}),
                    pageSize: 500,
                    role: 'seminarian',
                    'per-page': 1000
                }
            )
    }, [state.direction_id]);
    
    const {
        data: seminariansInCourses = [],
        loading: loadingSeminariansInCourses,
        setSearchQuery: setSearchQuerySeminariansInCourses,
    } = useApiSearch({
        apiMethod: usersAPI.searchUsersForSelect,
        responseKey: 'data',
        searchKey: 'name',
        params: paramsForSeminariansInCourses,
        notSendRequest: !state.direction_id,
        minQueryLength: 0
    });

    const fieldsSeminariansInCourses = {
        loading: loadingSeminariansInCourses,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: false,
        onChange: value => setFieldInState({field: 'teacher_id', value}),
        options: !state.direction_id ? [] : seminariansInCourses,
        value: state.teacher_id,
        placeholder: 'Выберите сотрудника курса',
        onSearch: setSearchQuerySeminariansInCourses,
        notFoundContent: !state.direction_id ? 'Сначала выберите курс' : "Сотрудники не найдены"
    };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsSeminariansInCourses} />
    );
};